<template>
  <div class="cover-content table-wrapper">
    <!-- <high-search> -->
    <Tabs :value="activeTabs" type="card" @on-click="tabsClikc">
      <TabPane label="有考勤项目清单" name="1"></TabPane>
      <TabPane label="无考勤项目清单" name="0"></TabPane>
    </Tabs>
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="120"
      label-position="right"
    >
      <Row :gutter="16">
        <Col span="6">
          <FormItem label="项目名称:">
            <Input
              v-model="formInline.projectName"
              placeholder="请输入项目名称"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目编号:">
            <Input
              v-model="formInline.projectCode"
              placeholder="请输入项目编号"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="考勤时间:">
            <DatePicker
              v-if="activeTabs == 1"
              type="date"
              placeholder="请选择考勤时间"
              :value="formInline.startDate"
              format="yyyy-MM-dd"
              @on-change="handleStartDate"
              :options="options1"
            ></DatePicker>
            <div v-if="activeTabs == 0">
              <DatePicker
                ref="dd"
                type="daterange"
                :value="formInline.time"
                @on-change="kqDateChange"
                @mouseup.native="nativeClick"
                :options="options2"
                placeholder="请选择考勤时间"
                transfer
              ></DatePicker>
              <Tooltip
                placement="right"
                theme="light"
                transfer
                class="tool"
                max-width="initial"
              >
                <span><Icon size="16" type="ios-help-circle-outline" /></span>
                <ul slot="content">
                  <li>注：如若查看非当前月无考勤项目清单时，请先清空考勤时间再选择。</li>
                </ul>
              </Tooltip>
            </div>
          </FormItem>
        </Col>

        <Col span="6" class="high-search">
          <FormItem :label-width="0">
            <Button type="primary" @click="getTableSearch">搜索</Button>
            <Button style="margin-left: 20px" @click="handleReset">重置</Button>
            <span
              :class="open ? 'search-open' : 'search-close'"
              @click="open = !open"
              >{{ open ? "收起" : "展开" }}
              <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'"
            /></span>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="项目状态:">
            <Select
              v-model="formInline.prjStatus"
              placeholder="请选择项目状态"
              filterable
              clearable
            >
              <Option
                v-for="(item, index) in projectStatus"
                :value="item.code"
                :key="index"
                >{{ item.name }}</Option
              >
              <!--<Option value="001">筹备</Option>-->
              <!--<Option value="002">立项</Option>-->
              <!--<Option value="003">在建</Option>-->
              <!--<Option value="004">完工</Option>-->
              <!--<Option value="005">停工</Option>-->
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="施工许可证状态:">
            <Select
              v-model="formInline.buildNumStatus"
              placeholder="请选施工许可证状态"
              filterable
            >
              <Option value="0">正在办理施工许可证</Option>
              <Option value="1">已办理施工许可证</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="项目类型:">
            <Select
              v-model="formInline.category"
              placeholder="请选择项目类型"
              filterable
            >
              <Option value="01">房屋建筑工程</Option>
              <Option value="02">市政公用工程</Option>
              <Option value="99">其他</Option>
            </Select>
          </FormItem>
        </Col>
        <!-- <Col span="6">
          <FormItem label="是否考勤:">
            <Select
              v-model="formInline.isKq"
              placeholder="请选择是否考勤"
              filterable
            >
              <Option value="是">是</Option>
              <Option value="否">否</Option>
            </Select>
          </FormItem>
        </Col> -->
      </Row>
      <Row :gutter="16" v-show="open">
        <Col span="6">
          <FormItem label="项目所在地:">
            <place-select v-model="formInline.areaCode"></place-select>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem label="施工许可证号：" prop="builderLicenseNum">
            <Input
              v-model="formInline.builderLicenseNum"
              placeholder="请输入施工许可证号"
            ></Input>
          </FormItem>
        </Col>
        <Col span="6" v-if="activeTabs == 0">
          <FormItem label="无考勤时间:">
            <Select
              v-model="formInline.noAttendanceDay"
              placeholder="请选择项目状态"
              filterable
              clearable
            >
              <Option
                v-for="(item, index) in noAttendanceTime"
                :value="item.value"
                :key="index"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="8">
          <Button
            :loading="eLoading"
            style="margin-bottom: 24px"
            icon="ios-exit-outline"
            type="primary"
            @click="handleExport"
            >导出</Button
          >
        </Col>
      </Row>
    </Form>
    <!-- </high-search> -->
    <div class="cover-table">
      <Table
        border
        style="width: 100%"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <span class="pointer" @click="handleDeal('checking-inList', row)"
            >详情</span
          >
        </template>
      </Table>
      <Page
        class="page"
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changeValue"
        @on-page-size-change="pageSizeValue"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
  </div>
</template>
<style scoped>
.tool {
  margin-left: 15px;
  margin-top: 0px;
  float: left;
  position: absolute;
  z-index: 100;
}
.marL {
  width: 100%;
  height: 32px;
}
.marL >>> .el-input__inner {
  display: inline-block;
  height: 32px;
}
.marL >>> .el-icon-date {
  margin-left: -9px;
  font-size: 14px;
  /* margin-top:-8px; */

  color: #c0c4cc;
  float: left;
  line-height: 32px;
}
.marL >>> .el-range-separator {
  margin-top: -8px;
  display: inline-block;
  width: 16%;
}
.marL >>> .el-range__close-icon {
  margin-top: -8px;
}
.marL >>> .el-input__suffix .el-input__icon {
  height: 32px;
  line-height: 32px;
}
</style>
<script>
import { mapState, mapGetters } from "vuex";
import tableMixin from "@/components/tableMixin";
import { format } from "../../../utils/forMat";

export default {
  mixins: [tableMixin],
  data() {
    return {
      noAttendanceTime: [
        {
          label: "3天及以上",
          value: 3,
        },
        {
          label: "5天",
          value: 5,
        },
        {
          label: "10天",
          value: 10,
        },
        {
          label: "15天",
          value: 15,
        },
        {
          label: "15天以上",
          value: 16,
        },
      ],
      pageSize: 10,
      page: 1,
      activeTabs: "1",
      eLoading: false,
      open: false,
      formInline: {
        builderLicenseNum: "",
        areaCode: localStorage.getItem("tenantAreaCode"), // 地区
        current: 1,
        endDate: "", // 结束时间
        projectName: "", // 项目名称
        size: 10,
        startDate: "", // 开始时间
        projectCode: "", // 项目编号
        category: "", // 类型
        prjStatus: "", // 项目状态
        // isKq: "", // 是否考勤:是,否
        buildNumStatus: "", //施工许可证状态
        noAttendanceDay: "", //无考勤天数选择
        time: [],
      },
      tableColumns: [],
      tableColumns1: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "项目名称",
          key: "name",
          minWidth: 210,
          tooltip: true,
          align: "left",
        },
        {
          title: "项目编号",
          key: "projectCode",
          minWidth: 180,
          tooltip: true,
          align: "left",
        },
        {
          title: "项目类型",
          key: "category",
          minWidth: 180,
          tooltip: true,
          align: "left",
        },
        {
          title: "项目属地",
          key: "areaName",
          minWidth: 140,
          tooltip: true,
          align: "left",
        },
        { title: "项目状态", key: "prjStatus", minWidth: 100, align: "left" },
        {
          title: "施工许可证状态",
          key: "buildNumStatus",
          minWidth: 210,
          align: "left",
        },
        {
          title: "施工许可证号",
          key: "builderLicenseNum",
          minWidth: 210,
          align: "left",
          tooltip: true,
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        { title: "在岗人数", key: "personNum", align: "left", minWidth: 100 },
        { title: "考勤日期", key: "workDate", minWidth: 120, align: "left" },
        {
          title: "考勤人数",
          key: "attendanceNum",
          align: "left",
          minWidth: 100,
        },
        {
          title: "出勤率",
          key: "attendanceRate",
          align: "left",
          minWidth: 100,
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          align: "center",
          minWidth: 100,
        },
      ],
      tableColumns2: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "项目名称",
          key: "name",
          minWidth: 210,
          tooltip: true,
          align: "left",
        },
        {
          title: "项目编号",
          key: "projectCode",
          minWidth: 180,
          tooltip: true,
          align: "left",
        },
        {
          title: "项目类型",
          key: "category",
          minWidth: 180,
          tooltip: true,
          align: "left",
        },
        {
          title: "项目属地",
          key: "areaName",
          minWidth: 140,
          tooltip: true,
          align: "left",
        },
        { title: "项目状态", key: "prjStatus", minWidth: 100, align: "left" },
        {
          title: "无考勤时间（天）",
          key: "maxNoAttendanceDayNum",
          minWidth: 160,
          align: "left",
        },
        {
          title: "无考勤日期",
          key: "noAttendanceDate",
          minWidth: 140,
          tooltip: true,
          align: "left",
        },
        {
          title: "最近一次考勤日期",
          key: "lastAttendanceDate",
          minWidth: 160,
          align: "left",
        },
        {
          title: "施工许可证状态",
          key: "buildNumStatus",
          minWidth: 210,
          align: "left",
        },
        {
          title: "施工许可证号",
          key: "builderLicenseNum",
          minWidth: 210,
          align: "left",
          tooltip: true,
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        { title: "在岗人数", key: "personNum", align: "left", minWidth: 100 },

        {
          title: "操作",
          slot: "action",
          fixed: "right",
          align: "center",
          minWidth: 100,
        },
      ],
      tableData: [],
      options1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      options2: {
        disabledDate(time) {
          let date = new Date();
          date.setDate(1);
          return (
            time.getTime() > Date.now() ||
            date - 24 * 60 * 60 * 1000 > time.getTime()
          );
        },
      },
    };
  },
  computed: {
    ...mapState(["navList", "area", "citys"]),
    ...mapGetters(["projectStatus"]),
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    nativeClick() {
      const target = this.$refs.dd.$refs.pickerPanel;
      const { from, to } = target.rangeState;
      target.handlePickClick = () => {
        let selecting = target.rangeState;
        let from1 = target.rangeState.from;
        let from2 = new Date(from1);
        let nextMonthFirstDay = new Date(
          from1.getFullYear(),
          from1.getMonth() + 1,
          1
        );
        nextMonthFirstDay.setDate(nextMonthFirstDay.getDate() - 1);
        nextMonthFirstDay = nextMonthFirstDay > Date.now() ? Date.now() : nextMonthFirstDay;
        if (from1 && selecting) {
          this.options2 = {
            disabledDate(time) {
              return (
                time.getTime() > nextMonthFirstDay || from2.setDate(1) > time.getTime()
              );
            },
          };
        }
      };
    },
    setDefaultDate() {
      this.formInline.startDate = "";
      this.formInline.endDate = "";
      this.formInline.time = [];
      //当前设定的日期时间
      let d = new Date(Date.now());
      let e = new Date(Date.now() - 24 * 60 * 60 * 1000 * 3);
      //前一天设定的日期时间
      let year2, month2, day2;
      // let year3, month3, day3;
      d.setTime(d.getTime());
      e.setTime(e.getTime());
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
      // [year3, month3, day3] = [e.getFullYear(), e.getMonth(), e.getDate()];
      let timeChanges1 = new Date(year2, month2, day2, 0);
      // let timeChanges2 = new Date(year3, month3, day3, 0);

      if (this.activeTabs == 1) {
        this.formInline.startDate = format(timeChanges1, "yyyy-MM-dd");
        this.formInline.endDate = "";
      } else {
        this.formInline.startDate = format(timeChanges1, "yyyy-MM-dd");
        this.formInline.endDate = format(timeChanges1, "yyyy-MM-dd");
      }
      this.formInline.time = [
        format(timeChanges1, "yyyy-MM-dd"),
        format(timeChanges1, "yyyy-MM-dd"),
      ];
      this.options2 = {
        disabledDate(time) {
          let date = new Date();
          date.setDate(1);
          return (
            time.getTime() > Date.now() ||
            date - 24 * 60 * 60 * 1000 > time.getTime()
          );
        },
      };
    },
    handleStartDate(val) {
      this.formInline.startDate = val;
      this.formInline.endDate = "";
    },
    handleReset() {
      this.pageSize = 10;
      this.page = 1;
      this.formInline = {
        areaCode: localStorage.getItem("tenantAreaCode"), // 地区
        current: 1,
        endDate: "", // 结束时间
        projectName: "", // 项目名称
        size: 10,
        startDate: "", // 开始时间
        projectCode: "", // 项目编号
        category: "", // 类型
        prjStatus: "", // 项目状态
        buildNumStatus: "",
        builderLicenseNum: "",
        noAttendanceDay: "",
        time: [],
      };
      this.setDefaultDate();
      this.getTableValue();
    },
    // 导出
    handleExport() {
      const {
        startDate,
        endDate,
        projectName,
        workerName,
        corpName,
        areaCode,
        projectCode,
        category,
        prjStatus,
        buildNumStatus,
        builderLicenseNum,
        noAttendanceDay,
      } = this.formInline;
      this.eLoading = true;
      this.axios({
        method: "post",
        url: "/worker/sx/projectAttendance/export",
        responseType: "arraybuffer",
        data: {
          isKq: Number(this.activeTabs),
          startDate: startDate,
          endDate,
          projectName,
          workerName,
          corpName,
          areaCode,
          size: this.pageSize,
          current: this.page,
          projectCode,
          category,
          prjStatus,
          buildNumStatus,
          builderLicenseNum,
          noAttendanceDay,
        },
      })
        .then((response) => {
          this.eLoading = false;
          this.common.download(
            response,
            "项目考勤.xls",
            "application/vnd.ms-excel"
          );
        })
        .catch(() => {
          this.eLoading = false;
        });
    },
    /*处理操作*/
    handleDeal(name, row) {
      this.$router.push({
        name: name,
        query: {
          projectName: row.name,
          projectId: row.projectCode,
          time: this.formInline.startDate,
        },
      });
    },
    /*获取表格数据*/
    getTableData() {
      this.activeTabs = "1";
      this.handleReset();
    },
    getTableSearch() {
      this.pageSize = 10;
      this.page = 1;
      this.getTableValue();
    },
    getTableValue() {
      if (this.activeTabs == 1) {
        this.tableColumns = this.tableColumns1;
      } else {
        this.tableColumns = this.tableColumns2;
      }
      const {
        startDate,
        endDate,
        projectName,
        workerName,
        corpName,
        areaCode,
        projectCode,
        category,
        prjStatus,
        buildNumStatus,
        builderLicenseNum,
        noAttendanceDay,
      } = this.formInline;
      this.loading = true;
      this.axios({
        method: "post",
        url: "/worker/sx/attendance/projects",
        data: {
          isKq: Number(this.activeTabs),
          startDate: startDate,
          endDate,
          projectName,
          workerName,
          corpName,
          areaCode: areaCode,
          size: this.pageSize,
          current: this.page,
          projectCode,
          category,
          prjStatus,
          buildNumStatus,
          builderLicenseNum,
          noAttendanceDay,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.records;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 选项切换
    tabsClikc(val) {
      this.activeTabs = val;
      this.handleReset();
    },
    kqDateChange(e) {
      this.formInline.time = e;
      if (e[0] == "" || e[1] == "") {
        this.formInline.startDate = this.formInline.time[0];
        this.formInline.endDate = this.formInline.time[1];
      } else {
        this.formInline.startDate = e[0];
        this.formInline.endDate = e[1];
      }
      if (e[0] == "" || e[1] == "") {
        this.options2 = {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        };
      }
    },
    /*新页数*/
    changeValue(value) {
      this.page = value;
      this.getTableValue();
    },
    /*每页的条数*/
    pageSizeValue(value) {
      this.pageSize = value;
      this.page = 1;
      this.getTableValue();
    },
  },
};
</script>
